import { useEffect, useState } from 'react';
import API_ENDPOINTS from '../../config/api';

/**
 * The map graph (API_ENDPOINTS.MAP_GRAPH, specs/map-graph.md) for a view that
 * reads the map's meaning — the node neighbourhood. Fetched when `key` changes (pass the
 * open node's id, so a newly drawn link is there next time a card opens). An error is
 * returned, never replaced with a guess.
 */
export default function useMapGraph(instanceId, key = null) {
  const [state, setState] = useState({ graph: null, error: null, loading: false });
  useEffect(() => {
    if (!instanceId) return undefined;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetch(API_ENDPOINTS.MAP_GRAPH(instanceId), { credentials: 'include', headers: { Accept: 'application/json' } })
      .then(async (r) => {
        if (!r.ok) throw new Error(`map graph: HTTP ${r.status}`);
        return r.json();
      })
      .then((graph) => { if (!cancelled) setState({ graph, error: null, loading: false }); })
      .catch((error) => { if (!cancelled) setState({ graph: null, error, loading: false }); });
    return () => { cancelled = true; };
  }, [instanceId, key]);
  return state;
}
